import Routes from '@app/config/router'
import { store } from '@app/store'
import { globalCss } from '@grupoboticario/flora'
import * as React from 'react'
import { Provider as ReduxProvider } from 'react-redux'

import { BaseLayout } from '@/components/layout/BaseLayout'

import { fontSecondary } from './styles/fonts.style'

const globalStyle = globalCss({
  ...fontSecondary,
  'html, body, body > div:first-of-type': {
    height: '100%',
  },
  label: {
    fontFamily: '$secondary',
    fontSize: '$md',
  },
})

function App() {
  globalStyle()

  return (
    <ReduxProvider store={store}>
      <BaseLayout>
        <Routes />
      </BaseLayout>
    </ReduxProvider>
  )
}

export default App
